// Startscherm na het inloggen: per persoon de ingangen.
//
//   - eigen gegevens, als je zelf lid of ouder bent
//   - elke organisatie waar je beheerder bent, met haar modules
//   - platformbeheer, en voor platformbeheer alle organisaties
//
// Een module heeft een van vier standen: actief (tik om te openen), uit (de
// organisatie heeft hem niet aan staan), niet voor dit type organisatie, of
// geen recht (je rol mag er niet bij). Welke organisaties en modules er zijn,
// komt uit public.mijn_contexten(); wat je daarbinnen mag, uit my_permissions.
import { t } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toast } from '../ui/toast.js';
import { koppelTaalkeuze } from '../lib/i18n.js';
import * as context from '../lib/context.js';
import * as eigendom from './eigendom.js';

// Pagina's en de permissie die ze vragen, gelijk aan router.js.
const MODULES = [
  { key: 'toernooien',    feature: 'toernooien', perm: 'data.read',       pagina: 'toernooien',     icoon: 'trophy' },
  { key: 'leden',         feature: 'leden',      perm: 'member.read',     pagina: 'leden',         icoon: 'users' },
  { key: 'bond',          feature: 'bond',       perm: 'member.read',     pagina: 'clubregister',  icoon: 'building' },
  { key: 'activiteiten',  feature: 'activiteiten', perm: 'data.read',   pagina: 'activiteiten',  icoon: 'calendar-event' },
  { key: 'goedkeuringen', feature: null,         perm: 'approval.decide', pagina: 'goedkeuringen', icoon: 'checkup-list' },
  { key: 'beheer',        feature: null,         perm: 'users.manage',    pagina: 'admins',        icoon: 'settings' },
];
const PLATFORM = [
  { pagina: 'dash', icoon: 'layout-dashboard' }, { pagina: 'orgs', icoon: 'building' },
  { pagina: 'terms', icoon: 'file-certificate' }, { pagina: 'email', icoon: 'mail' }, { pagina: 'stripe', icoon: 'credit-card' },
];

let sb = null;
let info = null;

function scherm() {
  let el = document.getElementById('startRoot');
  if (!el) {
    el = document.createElement('div');
    el.id = 'startRoot';
    el.className = 'start-root';
    document.body.appendChild(el);
    el.addEventListener('click', klik);
    el.addEventListener('submit', e => e.preventDefault());
    el.addEventListener('change', e => { if (e.target.matches('select[data-taalkeuze]')) teken(); });
  }
  for (const id of ['authScreen', 'deniedScreen', 'inviteScreen']) document.getElementById(id)?.classList.remove('active');
  const app = document.getElementById('appRoot');
  if (app) app.style.display = 'none';
  el.style.display = 'block';
  document.body.classList.remove('laden');
  return el;
}

// Stand van een module bij een organisatie.
export function stand(m, org, perms) {
  if (m.feature) {
    const f = org.modules?.[m.feature];
    if (!f?.aan) return f?.voor_type ? 'uit' : 'nvt';
  }
  // Via platformtoegang geldt elke permissie; als lid die van je rol.
  if (!org.lid) return org.toegang_tot ? 'actief' : 'geentoegang';
  return perms.has(m.perm) ? 'actief' : 'geenrecht';
}

export async function toon(client, gegevens) {
  sb = client;
  info = { ...gegevens, contexten: [], perms: {} };
  const el = scherm();
  el.innerHTML = '<div class="start-wrap"><div class="spinner"></div></div>';
  const [ctx, perms, aanb, aanvr, wacht] = await Promise.all([
    sb.rpc('mijn_contexten'),
    sb.from('my_permissions').select('organisation_id, permission_key'),
    sb.rpc('mijn_aanbiedingen'),
    sb.from('organisation_requests').select('*').order('created_at', { ascending: false }),
    sb.rpc('wacht_op_mij'),
  ]);
  // Verzoeken die op een organisatie wachten (C4), per organisatie.
  info.wacht = Object.fromEntries((wacht.error ? [] : wacht.data || []).map(r => [r.organisation_id, Number(r.aantal) || 0]));
  info.contexten = ctx.error ? [] : (ctx.data || []);
  info.aanbiedingen = aanb.error ? [] : (aanb.data || []);
  // Eigen aanvragen; platformbeheer ziet daarnaast alle open aanvragen.
  const alleAanvragen = aanvr.error ? [] : (aanvr.data || []);
  info.aanvragen = alleAanvragen.filter(a => String(a.aangevraagd_door).toLowerCase() === String(info.email || '').toLowerCase());
  info.teBeoordelen = info.platform ? alleAanvragen.filter(a => a.status === 'open') : [];
  info.fout = ctx.error ? ctx.error.message : null;
  for (const r of perms.data || []) (info.perms[r.organisation_id] ||= new Set()).add(r.permission_key);
  teken();
}

function moduleTegel(m, org) {
  const s = stand(m, org, info.perms[org.organisation_id] || new Set());
  const open = s === 'actief';
  return `<button type="button" class="start-tegel ${open ? '' : 'start-tegel-uit'}" ${open
      ? `data-start="org" data-org="${org.organisation_id}" data-pagina="${m.pagina}"` : 'disabled'}>
      <i class="ti ti-${m.icoon}"></i>
      <span class="start-tegel-naam">${esc(t('start.module.' + m.key))}${teller(m, org, open)}</span>
      <span class="start-tegel-stand">${esc(t('start.stand.' + s))}</span>
    </button>`;
}

// Op de tegel Leden (waar de verzoeken onder vallen): hoeveel verzoeken op u wachten.
function teller(m, org, open) {
  const n = info.wacht?.[org.organisation_id] || 0;
  return m.key === 'leden' && open && n
    ? ` <span class="badge badge-let" data-wacht title="${esc(t('verz.teller', { aantal: n }))}">${n}</span>` : '';
}

function typen(org) {
  return (org.types || []).map(tp => `<span class="badge badge-grey">${esc(t('start.type.' + tp))}</span>`).join(' ');
}

function teken() {
  const el = document.getElementById('startRoot');
  if (!el || !info) return;
  const eigen = info.contexten.filter(o => o.lid);
  const nu = Date.now();
  const tijd = iso => new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  el.innerHTML = `<div class="start-wrap">
    <div class="start-kop">
      <div><h1>${esc(t('start.titel', { merk: window.__merknaam || 'Tornema' }))}</h1>
        <div class="start-sub">${esc(info.email || '')}</div></div>
      <div class="start-acties">
        <div class="taal-keuze"><i class="ti ti-language"></i><select data-taalkeuze aria-label="Taal / Language"></select></div>
        <button type="button" class="btn btn-ghost btn-sm" data-start="uitloggen"><i class="ti ti-logout"></i> ${esc(t('auth.uitloggen'))}</button>
      </div>
    </div>
    ${info.fout ? `<div class="banner banner-amber"><i class="ti ti-alert-triangle"></i><span>${esc(t('start.nietbeschikbaar'))}</span></div>` : ''}

    ${info.aanbiedingen.map(a => `<section class="start-kaart start-kaart-let">
      <div class="start-kaart-kop"><i class="ti ti-key"></i> <strong>${esc(t(a.soort === 'nieuw' ? 'eigendom.aanbod.nieuw' : 'eigendom.aanbod.overdracht', { naam: a.organisatie }))}</strong></div>
      <p class="start-uitleg">${esc(t(a.soort === 'nieuw' ? 'eigendom.aanbod.nieuw.uitleg' : 'eigendom.aanbod.overdracht.uitleg', { van: a.van_email, reden: a.reden }))}</p>
      <div data-aanbod="${a.id}"><button type="button" class="btn btn-primary btn-sm" data-start="aanbod" data-id="${a.id}"><i class="ti ti-arrow-right"></i> ${esc(t('eigendom.bekijken'))}</button></div>
    </section>`).join('')}

    ${info.eigen ? `<section class="start-kaart">
      <div class="start-kaart-kop"><i class="ti ti-user-circle"></i> <strong>${esc(t('start.mijn'))}</strong></div>
      <p class="start-uitleg">${esc(t('start.mijn.uitleg'))}</p>
      <button type="button" class="btn btn-default btn-sm" data-start="mijn"><i class="ti ti-arrow-right"></i> ${esc(t('start.openen'))}</button>
    </section>` : ''}

    ${eigen.map(org => `<section class="start-kaart">
      <div class="start-kaart-kop"><i class="ti ti-building"></i> <strong>${esc(org.naam)}</strong> ${typen(org)}
        <span class="start-rol">${esc(t('start.rolnaam.' + (org.rol || 'viewer')))}</span>
        ${info.wacht?.[org.organisation_id] ? `<span class="badge badge-amber" data-wacht-kop>${esc(t('verz.teller', { aantal: info.wacht[org.organisation_id] }))}</span>` : ''}</div>
      ${org.toernooien?.length ? `<p class="start-uitleg"><i class="ti ti-trophy"></i> ${esc(t('start.toernooien', { lijst: org.toernooien.map(x => x.naam).join(', ') }))}</p>` : ''}
      <div class="start-tegels">${MODULES.map(m => moduleTegel(m, org)).join('')}</div>
    </section>`).join('')}

    ${magAanvragen() ? `<section class="start-kaart">
      <div class="start-kaart-kop"><i class="ti ti-building-plus"></i> <strong>${esc(t('eigendom.nieuw'))}</strong></div>
      <p class="start-uitleg">${esc(t('eigendom.nieuw.uitleg'))}</p>
      ${info.aanvragen.map(a => `<div class="org-row"><div style="flex:1"><strong>${esc(a.naam)}</strong>
          <span class="start-sub">${esc(t('eigendom.status.' + a.status))}${a.reden && a.status === 'afgewezen' ? ': ' + esc(a.reden) : ''}</span></div>
          ${a.status === 'open' ? `<button type="button" class="btn btn-ghost btn-sm" data-start="aanvraag-intrekken" data-id="${a.id}">${esc(t('eigendom.intrekken'))}</button>` : ''}</div>`).join('')}
      <div id="startAanvraag"><button type="button" class="btn btn-default btn-sm" data-start="aanvraag"><i class="ti ti-plus"></i> ${esc(t('eigendom.nieuw.knop'))}</button></div>
    </section>` : ''}

    ${info.platform ? `<section class="start-kaart start-kaart-platform">
      <div class="start-kaart-kop"><i class="ti ti-shield-bolt"></i> <strong>${esc(t('start.platform'))}</strong></div>
      <div class="start-tegels">${PLATFORM.map(p => `<button type="button" class="start-tegel" data-start="platform" data-pagina="${p.pagina}">
          <i class="ti ti-${p.icoon}"></i><span class="start-tegel-naam">${esc(t('titel.' + p.pagina))}</span></button>`).join('')}</div>
      ${info.teBeoordelen.length ? `<div class="start-kaart-kop" style="margin-top:14px"><strong>${esc(t('eigendom.beoordelen'))}</strong></div>
      ${info.teBeoordelen.map(a => `<div class="org-row"><div style="flex:1;min-width:220px"><strong>${esc(a.naam)}</strong>
          ${(a.types || []).map(tp => `<span class="badge badge-grey">${esc(t('start.type.' + tp))}</span>`).join(' ')}
          <span class="start-sub">${esc(a.aangevraagd_door)}${a.land ? ' &middot; ' + esc(a.land) : ''}${a.toernooi ? ' &middot; ' + esc(t('eigendom.aanvraag.metToernooi', { toernooi: a.toernooi })) : ''}${a.eerste_editie ? ' &middot; ' + esc(a.eerste_editie) : ''}</span>
          ${a.toelichting ? `<div class="start-uitleg" style="margin:2px 0 0">${esc(a.toelichting)}</div>` : ''}</div>
          <input class="form-input" data-reden="${a.id}" placeholder="${esc(t('eigendom.beoordelen.reden'))}" style="max-width:220px">
          <button type="button" class="btn btn-primary btn-sm" data-start="goedkeuren" data-id="${a.id}"><i class="ti ti-check"></i> ${esc(t('vierogen.goedkeuren'))}</button>
          <button type="button" class="btn btn-default btn-sm" data-start="afwijzen" data-id="${a.id}"><i class="ti ti-x"></i> ${esc(t('vierogen.afwijzen'))}</button>
        </div>`).join('')}` : ''}
      <div class="start-kaart-kop" style="margin-top:14px"><strong>${esc(t('start.alle'))}</strong></div>
      <p class="start-uitleg">${esc(t('start.alle.uitleg'))}</p>
      <div class="start-tabel-wrap"><table class="start-tabel">
        <thead><tr><th>${esc(t('start.kol.organisatie'))}</th>${MODULES.filter(m => m.feature).map(m => `<th>${esc(t('start.module.' + m.key))}</th>`).join('')}<th>${esc(t('start.kol.toegang'))}</th><th></th></tr></thead>
        <tbody>${info.contexten.map(org => {
          const toegang = org.lid ? t('start.toegang.lid') : org.toegang_tot && new Date(org.toegang_tot) > nu
            ? t('start.toegang.tot', { tijd: tijd(org.toegang_tot) }) : t('start.toegang.geen');
          const kan = org.lid || org.toegang_tot;
          return `<tr>
            <td><strong>${esc(org.naam)}</strong> ${typen(org)}</td>
            ${MODULES.filter(m => m.feature).map(m => {
              const f = org.modules?.[m.feature];
              const s = f?.aan ? 'aan' : f?.voor_type ? 'uit' : 'nvt';
              return `<td><span class="start-stip start-stip-${s}"></span>${esc(t('start.stip.' + s))}</td>`;
            }).join('')}
            <td>${esc(toegang)}</td>
            <td style="text-align:right">${kan
              ? `<button type="button" class="btn btn-default btn-sm" data-start="org" data-org="${org.organisation_id}"><i class="ti ti-arrow-right"></i> ${esc(t('start.openen'))}</button>`
              : `<button type="button" class="btn btn-ghost btn-sm" data-start="toegang" data-org="${org.organisation_id}"><i class="ti ti-key"></i> ${esc(t('start.toegang.aanvragen'))}</button>`}</td>
          </tr>
          <tr class="start-aanvraag" data-voor="${org.organisation_id}" hidden><td colspan="6">
            <div class="form-row" style="align-items:flex-end">
              <div class="form-group" style="flex:3"><label class="form-label">${esc(t('start.toegang.reden'))}</label>
                <input class="form-input" name="reden" placeholder="${esc(t('start.toegang.voorbeeld'))}"></div>
              <div class="form-group" style="max-width:120px"><label class="form-label">${esc(t('start.toegang.uren'))}</label>
                <select class="form-input" name="uren">${[1, 2, 4, 8].map(u => `<option value="${u}" ${u === 4 ? 'selected' : ''}>${u}</option>`).join('')}</select></div>
              <button type="button" class="btn btn-primary btn-sm" data-start="toegang-ok" data-org="${org.organisation_id}"><i class="ti ti-key"></i> ${esc(t('start.toegang.aanvragen'))}</button>
            </div></td></tr>`;
        }).join('')}</tbody></table></div>
    </section>` : ''}

    ${!info.eigen && !eigen.length && !info.platform ? `<div class="banner banner-amber"><span>${esc(t('start.niets'))}</span></div>` : ''}
  </div>`;
  koppelTaalkeuze(el);
}

// Een nieuw toernooi aanvragen mag wie ergens owner of admin is, en platformbeheer.
const magAanvragen = () => info.platform || info.contexten.some(o => o.lid && ['owner', 'admin'].includes(o.rol));

async function vraagToegang(orgId) {
  const rij = document.querySelector(`#startRoot .start-aanvraag[data-voor="${orgId}"]`);
  const reden = rij.querySelector('[name="reden"]').value.trim();
  const uren = Number(rij.querySelector('[name="uren"]').value) || 4;
  if (reden.length < 10) { toast(t('start.toegang.kort'), 'error'); return false; }
  const nu = new Date();
  const { error } = await sb.from('platform_access_grants').insert([{
    organisation_id: orgId, email: String(info.email || '').toLowerCase(), reason: reden,
    granted_at: nu.toISOString(), expires_at: new Date(nu.getTime() + uren * 3600 * 1000).toISOString(),
  }]);
  if (error) { toast(t('alg.fout', { melding: error.message }), 'error'); return false; }
  return true;
}

async function klik(e) {
  const k = e.target.closest('[data-start]');
  if (!k) return;
  const a = k.dataset.start;
  if (a === 'uitloggen') { context.wis(); await sb?.auth.signOut(); location.replace(location.pathname); }
  if (a === 'mijn') context.kies({ soort: 'mijn' });
  if (a === 'org') context.kies({ soort: 'org', org: k.dataset.org }, k.dataset.pagina || '');
  if (a === 'platform') context.kies({ soort: 'platform' }, 'platform-' + k.dataset.pagina);
  if (a === 'toegang') {
    const rij = document.querySelector(`#startRoot .start-aanvraag[data-voor="${k.dataset.org}"]`);
    rij.hidden = !rij.hidden;
  }
  if (a === 'aanbod') {
    const aanbod = info.aanbiedingen.find(x => x.id === k.dataset.id);
    await eigendom.aanvaardFormulier(document.querySelector(`#startRoot [data-aanbod="${aanbod.id}"]`), aanbod,
      org => context.kies({ soort: 'org', org }));
  }
  if (a === 'aanvraag') eigendom.aanvraagFormulier(document.getElementById('startAanvraag'), () => toon(sb, info));
  if (a === 'aanvraag-intrekken') {
    const { error } = await sb.rpc('toernooi_aanvraag_intrekken', { p_id: k.dataset.id });
    if (error) toast(eigendom.eigendomFout(error), 'error'); else await toon(sb, info);
  }
  if (a === 'goedkeuren' || a === 'afwijzen') {
    const reden = document.querySelector(`#startRoot [data-reden="${k.dataset.id}"]`)?.value || null;
    const { error } = await sb.rpc('toernooi_aanvraag_besluiten', { p_id: k.dataset.id, p_besluit: a, p_reden: reden });
    if (error) toast(eigendom.eigendomFout(error), 'error');
    else { toast(t(a === 'goedkeuren' ? 'eigendom.goedgekeurd' : 'eigendom.afgewezen'), 'success'); await toon(sb, info); }
  }
  if (a === 'toegang-ok' && await vraagToegang(k.dataset.org)) {
    context.kies({ soort: 'org', org: k.dataset.org });
  }
}
